import { createBrowserRouter } from 'react-router-dom';

import ClientRoutes from '@/user/client.router.tsx';
import AdminRouter from '@/admin/admin.router.tsx';
import PartnerRouter from '@/partner/partner.router.tsx';

const Router = createBrowserRouter([ClientRoutes, AdminRouter, PartnerRouter]);
export default Router;
